import {
	reOrgConstructionMaterialPricePeriodChangeConstants
}from "./constants"
import actions from "../../actions"

const initialState = {
	error              : null,
	isSending          : false,
	isFileSending      : false,
	paged              : {},
	changed            : null,
	listPeriod         : [],
	history            : {},
	periods            : [],
	isMaterialsSending : false,
	materials          : []
}

export default function (state = initialState, action){
	switch (action.type){
		case (reOrgConstructionMaterialPricePeriodChangeConstants.GetPaged.REQUEST):
		case (reOrgConstructionMaterialPricePeriodChangeConstants.Create.REQUEST):
		case (reOrgConstructionMaterialPricePeriodChangeConstants.Update.REQUEST):
		case (reOrgConstructionMaterialPricePeriodChangeConstants.Delete.REQUEST):
		case (reOrgConstructionMaterialPricePeriodChangeConstants.DeleteSelectedPrices.REQUEST):
		case (reOrgConstructionMaterialPricePeriodChangeConstants.DeleteFilteredPrices.REQUEST):
		case (reOrgConstructionMaterialPricePeriodChangeConstants.GetListPeriodRegionReOrg.REQUEST):
		case (reOrgConstructionMaterialPricePeriodChangeConstants.GetByFile.REQUEST):
		case (reOrgConstructionMaterialPricePeriodChangeConstants.SubmitReOrgPricesForPeriod.REQUEST):
		case (reOrgConstructionMaterialPricePeriodChangeConstants.GetHistoryPaged.REQUEST):
		case (reOrgConstructionMaterialPricePeriodChangeConstants.GetPricesByPeriodsPaged.REQUEST):
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case (reOrgConstructionMaterialPricePeriodChangeConstants.GetMaterialPricesByPeriods.REQUEST):
			return {
				...state,
				isMaterialsSending: true
			}
		case (reOrgConstructionMaterialPricePeriodChangeConstants.GetExampleFile.REQUEST):
		case (reOrgConstructionMaterialPricePeriodChangeConstants.GetOrgExampleFile.REQUEST):
		case (reOrgConstructionMaterialPricePeriodChangeConstants.GetOrgNotInputMaterials.REQUEST):
			return {
				...state,
				isFileSending : true,
				changed       : null
			}
		case (reOrgConstructionMaterialPricePeriodChangeConstants.GetPaged.FAILURE):
		case (reOrgConstructionMaterialPricePeriodChangeConstants.Create.FAILURE):
		case (reOrgConstructionMaterialPricePeriodChangeConstants.Update.FAILURE):
		case (reOrgConstructionMaterialPricePeriodChangeConstants.DeleteSelectedPrices.FAILURE):
		case (reOrgConstructionMaterialPricePeriodChangeConstants.DeleteFilteredPrices.FAILURE):
		case (reOrgConstructionMaterialPricePeriodChangeConstants.Delete.FAILURE):
		case (reOrgConstructionMaterialPricePeriodChangeConstants.GetListPeriodRegionReOrg.FAILURE):
		case (reOrgConstructionMaterialPricePeriodChangeConstants.GetByFile.FAILURE):
		case (reOrgConstructionMaterialPricePeriodChangeConstants.SubmitReOrgPricesForPeriod.FAILURE):
		case (reOrgConstructionMaterialPricePeriodChangeConstants.GetPricesByPeriodsPaged.FAILURE):
			return {
				...state,
				isSending : false,
				error     : action.payload
			}
		case (reOrgConstructionMaterialPricePeriodChangeConstants.GetMaterialPricesByPeriods.FAILURE):
			return {
				...state,
				isMaterialsSending : false,
				error              : action.payload
			}
		case (reOrgConstructionMaterialPricePeriodChangeConstants.GetExampleFile.FAILURE):
		case (reOrgConstructionMaterialPricePeriodChangeConstants.GetOrgExampleFile.FAILURE):
		case (reOrgConstructionMaterialPricePeriodChangeConstants.GetOrgNotInputMaterials.FAILURE):
			return {
				...state,
				isFileSending : false,
				error         : action.payload
			}
		case (reOrgConstructionMaterialPricePeriodChangeConstants.GetListPeriodRegionReOrg.SUCCESS):
			return {
				...state,
				isSending  : false,
				listPeriod : action.payload.result
			}
		case (reOrgConstructionMaterialPricePeriodChangeConstants.GetPaged.SUCCESS):
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}

		case (reOrgConstructionMaterialPricePeriodChangeConstants.GetPricesByPeriodsPaged.SUCCESS):
			return {
				...state,
				isSending : false,
				periods   : action.payload.result.periods,
				paged     : action.payload.result.materialPrices
			}
		case (reOrgConstructionMaterialPricePeriodChangeConstants.GetMaterialPricesByPeriods.SUCCESS):
			return {
				...state,
				isMaterialsSending : false,
				materials          : action.payload.result
			}
		case (reOrgConstructionMaterialPricePeriodChangeConstants.GetHistoryPaged.SUCCESS):
			return {
				...state,
				isSending : false,
				history   : action.payload.result
			}

		case (reOrgConstructionMaterialPricePeriodChangeConstants.Create.SUCCESS):
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.create : null
			}
		case (reOrgConstructionMaterialPricePeriodChangeConstants.Update.SUCCESS):
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.update : null
			}
		case (reOrgConstructionMaterialPricePeriodChangeConstants.Delete.SUCCESS):
		case (reOrgConstructionMaterialPricePeriodChangeConstants.DeleteSelectedPrices.SUCCESS):
		case (reOrgConstructionMaterialPricePeriodChangeConstants.DeleteFilteredPrices.SUCCESS):
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : null
			}
		case (reOrgConstructionMaterialPricePeriodChangeConstants.GetByFile.SUCCESS):
		case (reOrgConstructionMaterialPricePeriodChangeConstants.SubmitReOrgPricesForPeriod.SUCCESS):
			return {
				...state,
				isSending : false,
				changed   : actions.download
			}
		case (reOrgConstructionMaterialPricePeriodChangeConstants.GetExampleFile.SUCCESS):
		case (reOrgConstructionMaterialPricePeriodChangeConstants.GetOrgExampleFile.SUCCESS):
		case (reOrgConstructionMaterialPricePeriodChangeConstants.GetOrgNotInputMaterials.SUCCESS):
			return {
				...state,
				isFileSending: false
			}
		case (reOrgConstructionMaterialPricePeriodChangeConstants.CLEAR):
			return {
				...state,
				error              : null,
				isSending          : false,
				isFileSending      : false,
				paged              : {},
				changed            : null,
				listPeriod         : [],
				isMaterialsSending : false,
				materials          : []
			}
		default:
			return state
	}
}